import React from "react";
import classnames from "classnames";
import { withRouter } from "react-router-dom";

import { makeStyles } from "@material-ui/styles";

import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Fab from "@material-ui/core/Fab";

import ArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import ChatIcon from "@material-ui/icons/Chat";
import { COLORS } from "../utils/Theme";

const FAQs = [
  {
    answer:
      "Compass will serve meals against your order on a first in – first out basis against the demand in any of the cities where we are running this initiative. A single Order can also be used to cater to multiple demands. An invoice shall be emailed to you, once the demand(s) against your Order has been fulfilled.",
    question:
      "Who will decide on the allocation of the Meals against my order, and how?"
  },
  {
    answer:
      "Thank you for partnering with Compass Group India.The receipt is auto-generated, and you might have received it.We request you to check your junk / spam folder.If you still haven't received it, please drop an email to compass@letsfeedtogether.com and we will mail you a copy.We regret the inconvenience caused.",
    question: "I placed an order but didn't receive a receipt for it"
  }
];
const FAQSsTwo = [
  // {
  //   question: "How else can my organisation partner with Compass Group India?",
  //   answer:
  //     "You could fund our endeavour or help us in the distribution process. Please fill the form here, and our team would be happy to get in touch with you."
  // },
  // {
  //   question: "I need to give feedback about the partnership",
  //   answer:
  //     "Please write to us at compass@letsfeedtogether.com for any input or feedback. We shall be happy to get back to you."
  // }
];

const styles = makeStyles(theme => ({
  container: {
    textAlign: "left",
    width: "65%",
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      padding: "0px 15px",
      width: "95%"
    }
  },
  title: {
    fontWeight: "bold",
    padding: "20px 0px",
    fontSize: "24px",
    [theme.breakpoints.down("sm")]: {
      padding: "20px 0px 5px",
      fontSize: "18px"
    }
  },
  content: {
    fontSize: "18px",
    fontWeight: "bold",
    lineHeight: "1.8",
    opacity: "0.7",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px"
    }
  },
  themeColor: {
    color: theme.commonStyles.themeColor
  },
  foodImageContainer: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    textAlign: "center",
    width: "75%",
    margin: "auto",
    paddingTop: "20px",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  mealServedImage: {
    height: "200px",
    width: "200px",
    [theme.breakpoints.down("sm")]: {
      height: "100px",
      width: "100px"
    }
  },
  paddingLeft: {
    paddingLeft: "15px"
  },
  topBar: {
    width: "65%",
    margin: "auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  backBtn: {
    padding: "10px",
    background: "white",
    fontWeight: "bold"
  },
  hashtag: {
    color: theme.commonStyles.themeColor,
    padding: "8px 8px 10px",
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px"
    }
  },
  SupportButton: {
    position: "fixed",
    bottom: "125px",
    right: "150px",
    [theme.breakpoints.down("sm")]: {
      bottom: "50px",
      right: "25px"
    },
    backgroundColor: "#F37020",
    "&:hover": {
      backgroundColor: "#F37020",
      opacity: "0.7"
    }
  },
  titleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "65%",
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      padding: "15px 15px 0px",
      width: "100%"
    }
  },
  sectionTitle: {
    fontSize: "24px",
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px"
    }
  }
}));

const Faqs = props => {
  const classes = styles();

  const handleOpen = () => {
    props.history.push("/contact-us");
  };

  return (
    <div style={{ marginBottom: "110px", overflowX: "hidden" }}>
      <div className={classes.topBar}>
        <Button
          color="primary"
          className={classes.backBtn}
          startIcon={<ArrowLeft style={{ margin: 0 }} />}
          onClick={() => props.history.goBack()}
        >
          Go Back
        </Button>
        <Typography variant="h6" className={classes.hashtag}>
          #LetsFeedTogether
        </Typography>
      </div>
      <div className={classes.titleContainer}>
        <Typography variant="h6" className={classes.sectionTitle}>
          FAQs
        </Typography>
      </div>
      <div className={classes.container} id="info">
        <Typography
          variant="h4"
          className={classnames(classes.title, classes.themeColor)}
        >
          How is this Initiative Run?
        </Typography>
        {/* <p className={classes.content} style={{ margin: "0px" }}>
          Click here to{" "}
          <a href="/know-more" style={{ color: COLORS.PRIMARY_COLOR }}>
            know more
          </a>
          .
        </p> */}
        <span className={classes.content}>
          Click here to{" "}
          <p
            style={{
              textDecoration: "underline",
              color: COLORS.PRIMARY_COLOR,
              margin: "0px",
              display: "inline",
              cursor: "pointer"
            }}
            onClick={() => props.history.push("/know-more")}
          >
            know more
          </p>
        </span>
        {FAQs.map(({ question, answer }, index) => {
          return (
            <div key={index}>
              <Typography
                variant="h4"
                className={classnames(classes.title, classes.themeColor)}
              >
                {question}
              </Typography>
              <Typography variant="h6" className={classes.content}>
                {answer}
              </Typography>
            </div>
          );
        })}
        {FAQSsTwo.map(({ question, answer }, index) => {
          return (
            <div key={index}>
              <Typography
                variant="h4"
                className={classnames(classes.title, classes.themeColor)}
              >
                {question}
              </Typography>
              <Typography variant="h6" className={classes.content}>
                {answer}
              </Typography>
            </div>
          );
        })}
      </div>
      {/* <Fab className={classes.SupportButton} onClick={handleOpen}>
        <ChatIcon style={{ color: "white" }} />
      </Fab> */}
    </div>
  );
};

export default withRouter(Faqs);
